import { render } from "./Dashboard.vue?vue&type=template&id=db5a7b0c&scoped=true&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=db5a7b0c&lang=scss&scoped=true"
import "./Dashboard.vue?vue&type=style&index=1&id=db5a7b0c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5a7b0c"]])

export default __exports__